/**
 * GCS — PDP Price Refresh on Variant Change
 *
 * Theme uses a custom_liquid block (Bebas Neue 40px inline-styled spans) for the
 * main visible price instead of Dawn's standard product__price element with an ID.
 * As a result, Dawn's built-in renderProductInfo can't find the price target on
 * variant change — customers selecting a different size see stale price/compare/save
 * values until they refresh.
 *
 * This script subscribes to the existing PUB_SUB_EVENTS.variantChange event the
 * theme already fires on every variant selection, and updates:
 *   1. Main price block (Bebas Neue inline-styled div containing the three spans)
 *   2. Sticky ATC bar price (#gcsStickyPrice + .gcs-sticky-atc-compare)
 *   3. SAVE ribbon overlay on the product media gallery (.gcs-save-ribbon)
 *
 * Both `subscribe` and `PUB_SUB_EVENTS` are referenced as bare globals — they live
 * in pubsub.js + constants.js as classic-script declarations (function + const),
 * and `const` at top level does NOT attach to window, so `window.PUB_SUB_EVENTS`
 * is undefined. Bare references resolve via the global scope chain instead.
 */

(function () {
  'use strict';

  var DEBUG = true;
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[gcs-pdp]'].concat([].slice.call(arguments))); }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var dollars = cents / 100;
    return '$' + dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function findCustomPriceBlock() {
    var divs = document.querySelectorAll('div[style*="Bebas Neue"][style*="40px"]');
    for (var i = 0; i < divs.length; i++) {
      if (divs[i].querySelector('span')) return divs[i];
    }
    return null;
  }

  function updateMainPriceBlock(variant) {
    var block = findCustomPriceBlock();
    if (!block) { log('main price block NOT FOUND'); return; }

    var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (hasCompare) {
      var savings = variant.compare_at_price - variant.price;
      block.innerHTML =
        '<span>' + formatMoney(variant.price) + '</span>' +
        '<span style="font-family:\'Inter\',sans-serif; font-size:16px; color:#6b6b68; text-decoration:line-through; font-weight:500;">' +
          formatMoney(variant.compare_at_price) +
        '</span>' +
        '<span style="background:#f9d905; color:#0b0b0b; font-family:\'Inter\',sans-serif; font-size:11px; font-weight:700; padding:3px 9px; border-radius:4px; letter-spacing:0.05em; text-transform:uppercase;">' +
          'Save ' + formatMoney(savings) +
        '</span>';
    } else {
      block.innerHTML = '<span>' + formatMoney(variant.price) + '</span>';
    }
    log('main price updated to', formatMoney(variant.price));
  }

  function updateStickyPrice(variant) {
    var stickyPrice = document.getElementById('gcsStickyPrice');
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    var compareEl = document.querySelector('.gcs-sticky-atc-compare');
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  function updateSaveRibbon(variant) {
    var ribbon = document.querySelector('.gcs-save-ribbon');
    if (!ribbon) return;
    var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (hasCompare) {
      var savings = variant.compare_at_price - variant.price;
      ribbon.textContent = 'SAVE ' + formatMoney(savings);
      ribbon.style.display = '';
    } else {
      ribbon.style.display = 'none';
    }
  }

  function onVariantChange(event) {
    log('variantChange event fired', event);
    var variant = event && event.data && event.data.variant;
    if (!variant) { log('no variant in event'); return; }
    updateMainPriceBlock(variant);
    updateStickyPrice(variant);
    updateSaveRibbon(variant);
  }

  function init(retries) {
    retries = retries || 0;
    // Use BARE references — `subscribe` is hoisted to window from pubsub.js,
    // but `PUB_SUB_EVENTS` is a `const` and does NOT attach to window.
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      if (retries < 60) {
        setTimeout(function () { init(retries + 1); }, 100);
      } else {
        log('FAILED to find subscribe / PUB_SUB_EVENTS after 6s');
      }
      return;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    log('subscribed to variantChange');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(0); });
  } else {
    init(0);
  }
})();
